class BCCartDelivery extends HTMLElement {
  connectedCallback() {
    const addBusinessDays = (days) => {
      const date = new Date();
      for (let added = 0; added < days; ) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
      }
      return date;
    };

    const format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
      month: 'short',
      day: 'numeric',
    });

    this.textContent = `${format.format(addBusinessDays(5))}–${format.format(addBusinessDays(10))}`;
  }
}

if (!customElements.get('bc-cart-delivery')) {
  customElements.define('bc-cart-delivery', BCCartDelivery);
}
